import { render, staticRenderFns } from "./messageTemplate.vue?vue&type=template&id=30eb77d3&scoped=true"
import script from "./messageTemplate.vue?vue&type=script&lang=js"
export * from "./messageTemplate.vue?vue&type=script&lang=js"
import style0 from "./messageTemplate.vue?vue&type=style&index=0&id=30eb77d3&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eb77d3",
  null
  
)

export default component.exports